import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
// Submits the closest form when any input fires `input` or `change`.
// Use data-auto-submit-delay-value (ms) for debouncing text inputs.
export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } }

  connect() {
    this._timer = null
  }

  submit(event) {
    const form = event?.target?.form || this.element.closest("form") || this.element
    if (!form) return

    if (this.delayValue > 0) {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => form.requestSubmit(), this.delayValue)
    } else {
      form.requestSubmit()
    }
  }
}
